import { render, staticRenderFns } from "./FinancePage.vue?vue&type=template&id=bbcd8bce&"
import script from "./FinancePage.vue?vue&type=script&lang=js&"
export * from "./FinancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports